import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoggerFactory } from 'app/core/logger.service';
import { SiteSpecific } from 'app/core/site-specific.base';
import { HttpRequestDecorator } from 'app/core/triggerbee/http.request.decorator';
import { TriggerbeeApi } from 'app/core/triggerbee/triggerbee-requester.service';
import { UserSession } from 'app/core/user-session';

@Component({
  selector: 'app-data-exports',
  templateUrl: './data-exports.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DataExportsComponent extends SiteSpecific {
  public canDownload: boolean;
  private filename: string;
  private type: string;

  constructor(
    protected readonly loggerFactory: LoggerFactory,
    protected readonly userSession: UserSession,
    private readonly activatedRoute: ActivatedRoute,
    private http: HttpRequestDecorator,
  ) {
    super(userSession, loggerFactory);
  }

  protected onSiteChanged() {
    this.filename = this.activatedRoute.snapshot.queryParams['filename'];
    this.type = this.activatedRoute.snapshot.data['type'];

    if (this.filename) {
      this.canDownload = true;
      this.downloadFile();
    }
  }

  public async downloadFile() {
    const response = await this.http.getDownload(this.getUrl()).toPromise();
    if (response) {
      this.downloadFileBlob(response);
    } else {
      this.canDownload = false;
    }
  }

  private getUrl(): string {
    const baseurl = this.http.getBaseUrl(TriggerbeeApi.Gateway);
    const path = this.type === 'response-list' ? 'response-lists/export-list' : 'admin/widgets/export';
    return `${baseurl}/${path}/${this.filename}`;
  }

  downloadFileBlob(data: any) {
    const blob = new Blob([data], { type: 'text/csv' });
    const fileURL = URL.createObjectURL(blob);

    const hiddenElement = document.createElement('a');
    hiddenElement.href = fileURL;
    hiddenElement.target = '_blank';
    hiddenElement.download = this.filename;
    hiddenElement.click();
    hiddenElement.remove();
  }
}
